export enum LocationSearchConstants {
  SET_ERROR_MSGS_MAP = 'locationSearch/SET_ERROR_MSGS_MAP',
  GET_PATIENT_CITY_NEMSIS_CODE = 'locationSearch/GET_PATIENT_CITY_NEMSIS_CODE',
  GET_PATIENT_EMPLOYER_CITY_NEMSIS_CODE = 'locationSearch/GET_PATIENT_EMPLOYER_CITY_NEMSIS_CODE',
  GET_REF_CITY_NEMSIS_CODE = 'locationSearch/GET_REF_CITY_NEMSIS_CODE',
  GET_REC_CITY_NEMSIS_CODE = 'locationSearch/GET_REC_CITY_NEMSIS_CODE',
  RESET_LOCATION_SEARCH_STATE = 'locationSearch/RESET_LOCATION_SEARCH_STATE',
  SET_ENABLE_LOCATION_SEARCH = 'locationSearch/SET_ENABLE_LOCATION_SEARCH',
}
